import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { DecimalPipe } from '@angular/common';
import {
  AccidentBenefit,
  CapitalOfDailyCash,
  CapitalOfHospitalCapital,
  CapitalOfHospitalDailyCash,
  CostSharing,
  DeathBenefit,
  DentalLevel,
  DisabilityBenefit,
  WaitingPeriodDailyCash,
  WaitingPeriodHospitalDailyCash,
} from '../api';

export type ParseableAmount =
  | CapitalOfHospitalDailyCash
  | CapitalOfDailyCash
  | CapitalOfHospitalCapital
  | DeathBenefit
  | DentalLevel
  | CostSharing
  | DisabilityBenefit
  | WaitingPeriodDailyCash
  | WaitingPeriodHospitalDailyCash
  | AccidentBenefit;

@Injectable({
  providedIn: 'root',
})
export class TranslateWithAmountService {
  constructor(
    private translateService: TranslateService,
    private decimalPipe: DecimalPipe,
  ) {}

  public stream$(value: string, parseableAmount?: ParseableAmount): Observable<string> {
    let amount = this.parseAmount(parseableAmount);

    return this.translateService.stream(value, { amount });
  }

  public instant(value: string, parseableAmount?: ParseableAmount): string {
    let amount = this.parseAmount(parseableAmount);
    return this.translateService.instant(value, { amount });
  }

  private parseAmount(parseableAmount?: ParseableAmount): string | null {
    if (parseableAmount) {
      const splitted = parseableAmount.split('_');
      const num = splitted[splitted.length - 1];
      return this.decimalPipe.transform(num);
    }
    return null;
  }
}
